import SocialCommon from './containers/socialCommon'

export {default as SocialCommonLayout} from './components/socialCommonLayout'

export default SocialCommon
